module.exports = __webpack_public_path__ + "img/vip-tag-regular.93944cd8.png";